import React, { useCallback, useRef, useState, useEffect } from "react";
import { connect } from "react-redux";
import { GridLayout } from "../../common/GridLayout";
import { LoadPanel } from 'devextreme-react/load-panel';
import notify from 'devextreme/ui/notify';
import data from "../../assets/apiRoutes.json";
import { createStore } from 'devextreme-aspnet-data-nojquery';
import {
    Column,
    DataGrid,
    GroupPanel,
    Scrolling,
    Grouping,
    FilterRow,
    HeaderFilter,
    FilterPanel,
    Sorting,
    Paging,
    Selection,
    Editing,
    RequiredRule,
    Item,
    Export,
    Pager,
    ColumnChooser,
    ColumnChooserSearch,
    StateStoring,
    ColumnHeaderFilter,
    Toolbar,
} from "devextreme-react/data-grid";
import "jspdf-autotable";
import "../css/omstyle.css";
import GridLayoutManager from "../../gridLayoutCustomization/GridLayoutManager";
let dataGrid;
const TransactionDetails = (props) => {
    var accessToken = props.oidc.user.access_token;
    const [loadPanelVisible, setLoadPanelVisible] = useState(false);
    const Ompricelevel = props.oidc.user.profile.OMDEFAULTPRICELEVEL;
    const hideLoadPanel = useCallback(() => {
        setLoadPanelVisible(false);

    }, [setLoadPanelVisible]);
    const [showEmployeeInfo, setShowEmployeeInfo] = useState();
    const [selectedRowKeys, setSelectedRowKeys] = useState([]);
    const [showIndicator, setShowIndicator] = useState(true);
    const [shading, setShading] = useState(true);
    const [showPane, setShowPane] = useState(true);
    const [hideOnOutsideClick, setHideOnOutsideClick] = useState(false);
    const [dataSource, setDataSource] = useState(null);
    const detailDataGrid = useRef(null);
    const getSelectedRows = () => {
        if (detailDataGrid && detailDataGrid.current) {
            return detailDataGrid.current.instance().getSelectedRowKeys();
        }
        return [];
    };
    const position = { of: '#accordion-containe2' };
    var permissions = props.ReceiptReducer.rolePermissions;
    const allowedPageSizes = [10, 20, 100, 500, 1000, "all"];
    const gridKey = "f6b3c5cd-4602-4661-aa50-ee619f9468b8";
    const [currentLayout, setCurrentLayout]= useState("Default");
    const loadState = useCallback(() => { return GridLayout.sendStorageRequest(gridKey, "GET", accessToken,null,currentLayout); }, [currentLayout]);
    const saveState = useCallback((state) => {GridLayout.sendStorageRequest(gridKey, "POST", accessToken, state, currentLayout); }, [gridKey, currentLayout]);
    
    const fetchData = (accessToken, selectedTab) => {
        const resultData = createStore({
            key: ['rowid', 'lotId', 'itemHeaderId', 'transactionId'],
            loadParams:
            {
                headerId: function () {
                    return props.headerRowId;
                }
            },
            loadUrl: `${window._env_.REACT_APP_APIS}/${data.OM.GetDetailItemsByHeaderId}`,
            updateUrl: `${window._env_.REACT_APP_APIS}/${data.OM.UpdateItem}`,
            onBeforeSend: (method, ajaxOptions) => {
                ajaxOptions.headers = {
                    access_token: accessToken,
                    Authorization: `Bearer ${accessToken}`,
                };
            },
            onModified: (method, ajaxOptions) => {
                const dataGridInstance = detailDataGrid.current.instance();
                const dataSource = dataGridInstance.getDataSource();
                dataGridInstance.option("disabled", true);
                dataSource.reload().done(() => {
                    dataGridInstance.option("disabled", false);
                });
                notify(
                    {
                        message: 'Record has been updated successfully.',
                        width: 100,
                    },
                    'success',
                    3000,
                );
            },
            errorHandler: (error) => {
                notify(
                    {
                        message: 'Error: Something went wrong try again',
                        width: 100,
                    },
                    'error',
                    3000,
                );
                console.error('Error:', error); // Log the error to the console
            },
        });
        return resultData;
    }
    useEffect(() => {
        const resultData = fetchData(accessToken, props.selectedTab);
        detailDataGrid.current.instance().option("dataSource", resultData);
    }, []);
    return (
        <div >
            <LoadPanel
                shadingColor="rgba(0,0,0,0.4)"
                position={position}
                onHiding={hideLoadPanel}
                visible={loadPanelVisible}
                showIndicator={showIndicator}
                shading={shading}
                showPane={showPane}
                hideOnOutsideClick={hideOnOutsideClick}
            />
            <DataGrid

onExporting={(e) => {
          if (window.handleDevExtremeDataGridExport) {
            window.handleDevExtremeDataGridExport(e);
          }
        }}
                allowColumnReordering={true}
                allowColumnResizing={true}
                ref={detailDataGrid}
                showBorders={true}
                hoverStateEnabled={true}
                className={props.searchPanelStatus ? "GridHeightAccordianOpen-tabs" : "GridHeightAccordianClose-tabs"}
                searchExpr="status"
                remoteOperations={true}
                searchEnabled={true}
                columnAutoWidth={true}
                scrolling={{ mode: "standard" }}
            >
                <ColumnChooser
                    enabled={true}
                    title="Choose Column"
                    width={290}
                    height={290}
                    sortOrder="asc"
                >
                    <ColumnChooserSearch
                        enabled={true}
                        editorOptions={{ placeholder: 'Search column' }} />
                </ColumnChooser>
                <Export enabled={true} allowExportSelectedData={true} />
                <Sorting visible={true} mode="multiple" />
                <Paging defaultPageSize={10} />
                <Pager
                    visible={true}
                    showPageSizeSelector={true}
                    allowedPageSizes={allowedPageSizes}
                    showNavigationButtons={true}
                />
                <Editing mode="cell"
                    allowUpdating={true} refreshMode="repaint" />
                <FilterRow visible={true} />
                <FilterPanel visible={true} />
                <HeaderFilter enabled={false} visible={false} />
                <GroupPanel visible={false} />
                <Grouping autoExpandAll={false} />
                <StateStoring
                    enabled={true}
                    type="custom"
                    customLoad={loadState}
                    storageKey={gridKey}
                    customSave={saveState}
                />
                <Sorting mode="multiple" />
                <Scrolling rowRenderingMode="virtual" />
                <FilterRow visible={true} />
                <Scrolling mode="virtual" />
                <Column dataField="selected" dataType="boolean" caption=""
                    fixed={true} allowReordering={false} allowResizing={false}

                >
                </Column>
                <Column
                    dataField="quantityorder"
                    dataType="number"
                    caption="Ordered"
                    allowReordering={false} allowResizing={false}
                    defaultSortOrder="desc"
                >

                </Column>
                <Column dataField="warehouse" caption='Warehouse' allowEditing={false} ></Column>
                <Column dataField="itemCode" caption='Item' allowEditing={false} ></Column>
                <Column dataField="description_1" caption='Description' allowEditing={false} ></Column>
                <Column dataField="lotcode" caption='Lot' allowEditing={false} ></Column>
                <Column dataField="lotDescription1" caption='Lot Description' allowEditing={false} ></Column>
                <Column dataField="classCode" caption='Item Class Code' allowEditing={false} ></Column>
                <Column dataField="subClassCode" caption='Item SubClass Code' allowEditing={false} ></Column>
                <Column dataField="status" caption='Item Status' allowEditing={false} ></Column>
                <Column dataField="lotstatus" caption='Lot Status' allowEditing={false} ></Column>
                <Column dataField="available" caption='Available Qty' allowEditing={false} ></Column>
                <Column dataField="netavailable" caption='Net Available Qty' allowEditing={false} ></Column>
                <Column dataField="unitPriceItem" dataType="number" format="#0.00" caption='Unit Price' allowEditing={false} ></Column>
           <Toolbar>
                    <Item location="after">
                        <GridLayoutManager gridKey={gridKey} dataGrid={dataGrid} setCurrentLayout={setCurrentLayout} />
                    </Item>
                    <Item>
                    </Item>
                    <Item name="exportButton" />
                    <Item name="columnChooserButton" />
           </Toolbar>
            </DataGrid>
        </div>
    );
};
function mapStateToProps(state) {
    return {
        oidc: state.oidc,
        ReceiptReducer: state.ReceiptReducer,
    };
}
export default connect(mapStateToProps)(TransactionDetails);